import { useScrollTrigger } from '@mui/material'
import { orderApiSpace } from 'feature/productOrder/namespaces/orderApiSpace'
import { FC, useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useAppSelector, useActions } from 'store/hooks'
import { MenuItem, SelectDropdown } from 'ui'
import { ProductParamsIcon } from 'widget/ProductParamsIcon/ProductParamsIcon'

import style from './InputDropdown.module.scss'

interface IInputDropdown {
  data: orderApiSpace.ProductParamData
  productId: number
}

export const InputDropdown: FC<IInputDropdown> = ({ data, productId }) => {
  const { control } = useForm()
  const { setParamOrder } = useActions()
  const trigger = useScrollTrigger()

  const currentEditForm = useAppSelector(
    state => state.orderForm.currentEditForm,
  )
  const params = useAppSelector(
    state => state.orderForm.forms[currentEditForm].params,
  )
  const param = params.find(item => item.id === data.id)
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    if (!isOpen) {
      setIsOpen(false)
    }
  }, [isOpen, trigger])

  const onChangeHandler = ({ id, value }: { id: number; value: string }) => {
    setIsOpen(false)
    setParamOrder({
      id: data.id,
      name: data.name,
      iconUrl: data.iconUrl,
      type: data.typeCode,
      productId: productId,
      value: value,
      selectId: id,
    })
  }

  return (
    <Controller
      name={`${data.id}_${data.name}`}
      control={control}
      render={({ field }) => (
        <div className={style.inputTextWithIcon}>
          <ProductParamsIcon url={data.iconUrl} name={data.name} />
          <SelectDropdown
            selectProps={{
              ...field,
              open: isOpen,
              onOpen: () => {
                setIsOpen(true)
              },
              onClose: () => {
                setIsOpen(false)
              },
              label: data.name,
              value: param?.value || '',
              className: style.dropDown,
            }}
            formControlProps={{ sx: { minWidth: '100%' } }}
          >
            {data.typeValues?.map(item => (
              <MenuItem
                value={item.value}
                key={item.value}
                onClick={() => {
                  onChangeHandler(item)
                }}
              >
                {item.value}
              </MenuItem>
            ))}
          </SelectDropdown>
        </div>
      )}
    />
  )
}
